module.exports = __webpack_public_path__ + "img/57.dc0d7499.jpg";